import utils from '../../others/utils';

export default {
  setActive(state, value) {
    console.log('STORE setActive', value);
    state.active = value;
  },
  setW_P(state, value) {
    console.log('MUTATION setWikis', value);
    state.wikis = value;
    state.parents = utils.calcParents(state.wikis);
  },
  delFromW_P(state, id) {
    console.log('MUTATION delFromW_P', id);
    delete state.wikis[id];
    state.parents = utils.calcParents(state.wikis);
  },
  setCurrentItem(state, value) {
    console.log('STORE setCurrentItem', value);
    state.currentItem = value;
  },
  setAuthorName(state, value) {
    console.log('STORE setAuthorName', value);
    state.authorName = value;
  },
};



// WEBPACK FOOTER //
// ./src/store/wiki/mutations.js